import { Frame } from '@shopify/polaris'
import { ReactNode, useEffect, useState } from 'react'

import { useSidebar } from '../providers/SidebarProvider'

import './AdminLayout.css'
import { AdminNavBar } from './AdminNavBar'
import { MobileHeader } from './MobileHeader'

interface AdminLayoutProps {
  children: ReactNode
}

export function AdminLayout({ children }: AdminLayoutProps) {
  const { isMinimized, setSidebarMinimized } = useSidebar()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const isMobile = window.innerWidth <= 768
      setIsMobile(isMobile)
      if (isMobile) {
        setSidebarMinimized(false)
      }
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return (
    <Frame>
      <div className="admin-layout">
        <AdminNavBar isMobile />
        <main
          className={`admin-main-content ${
            isMinimized ? 'sidebar-minimized' : ''
          } ${isMobile ? 'mobile' : ''}`}
        >
          <MobileHeader />
          <div className="content-wrapper">{children}</div>
        </main>
      </div>
    </Frame>
  )
}
